import React, { useState } from 'react';
import './teamCard.css'
import { useNavigate } from 'react-router-dom';
import teamMember from '../../../assets/images/tim_regan_dropbox-2a@2x.png'
import MermberInfoModal from '../MermberInfoModal/MermberInfoModal';
const TeamCard = ({ isinvestment, teamData, teamInfo }) => {
    const navigate = useNavigate();
    const [show, setShow] = useState(false)
    const text = `${teamInfo?.name[0]?.text + teamInfo?.short_design}`
  

    return (
        <>
            {/* <style>{conditionalStyle}</style> */}
            <MermberInfoModal isinvestment={isinvestment} show={show} teamInfo={show ? teamInfo : null} setShow={setShow} />
            <div onClick={() => setShow(true)} className={isinvestment ? "col-md-6 col-lg-4 col-6" : "row gx-2"}>

                <div className={!isinvestment ? "col-md-12 gx-3 gy-1" : " "}>
                    <div className="team-card position-relative">
                        <div className="card border-0 text-white   ">
                            <img src={teamInfo?.img?.url ? teamInfo?.img.url : teamMember} className="img-fluid" alt="..."></img>
                            <div className="card-img-overlay p-0 m-0">
                                <div
                                    style={{height: text?.length < 45 ? "52px" : "inherit"}}
                                
                                className="team-info backdrop-blur">
                                <h5 className='p-0 m-0'>{teamInfo?.name[0]?.text || "mamber name"}</h5>
                                <p className='p-0 m-0 d-none d-lg-block d-xl-block'>{teamInfo?.short_design ? teamInfo?.short_design : "designation"}</p>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>




        </>
    );
};

export default TeamCard;